import { normalizePhone } from '@ecosconnect/core/src/helpers/string';

export const formatPhone = (phone: string): string =>
  /^\+1\d{10}$/.test(phone) ? normalizePhone(phone.slice(2)) : phone;
